module.exports = __webpack_public_path__ + "img/adviser.b7e1f230.png";